import { getMyPermissions } from "api/services/roles";
import Loader from "components/Loader";
import React from "react";
import { useQuery } from "react-query";
import { ResType } from "types";

type Type = {
  permissions: string[];
};

export const PermissionsContext = React.createContext<Type>({
  permissions: [],
});

function PermissionsProvider({ children }) {
  const clientId = localStorage.getItem("clientId");
  const { data, isLoading }: ResType = useQuery(
    ["my-permissions", clientId],
    getMyPermissions,
    {
      enabled: !!localStorage.getItem("isLogIn"),
    }
  );
  if (isLoading) return <Loader minHeight="60vh" />;

  return (
    <PermissionsContext.Provider
      value={{
        permissions:
          data?.data?.map((item: any) => item?.slug) || [],
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
}

export const usePermissions = () => React.useContext(PermissionsContext);

export default PermissionsProvider;
